var _defs, _polyline, _polyline2, _line, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempProfilWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2e5b5af-5f81-45b5-ae04-b30c46291790",
    "data-name": "coef_temp_profil",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a1c05c42-8202-463a-9fd2-34c8d5fa4d06,.a1cafad3-46ac-46ea-b625-e40b6b079958,.bdc5f95a-a5f0-4d01-8b7f-2359c81c0f25,.eefabf8a-b0fc-426c-a0fc-5ea00847762f,.f7175566-c58a-4158-93ca-1764084d3297{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.bdc5f95a-a5f0-4d01-8b7f-2359c81c0f25{stroke-width:10px;}.f7175566-c58a-4158-93ca-1764084d3297{stroke-width:5px;}.a1c05c42-8202-463a-9fd2-34c8d5fa4d06{stroke-width:8px;}.ae93a8a8-8cf9-48ef-827b-c1294b93889d{fill:#fff;}.a1cafad3-46ac-46ea-b625-e40b6b079958{stroke-width:3px;}.eefabf8a-b0fc-426c-a0fc-5ea00847762f{stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_profil_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "bdc5f95a-a5f0-4d01-8b7f-2359c81c0f25",
    points: "195 149.5 49.5 149.5 49.5 5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "bdc5f95a-a5f0-4d01-8b7f-2359c81c0f25",
    points: "195 101 98 101 98 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f7175566-c58a-4158-93ca-1764084d3297",
    x1: 99,
    y1: 100,
    x2: 50,
    y2: 149
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a63aa458-3828-4ddb-8542-dc75a50881a3",
    "data-name": "termostat_mic copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a1c05c42-8202-463a-9fd2-34c8d5fa4d06",
    d: "M35.41,161.06a19.5,19.5,0,1,1-23.85,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a1c05c42-8202-463a-9fd2-34c8d5fa4d06",
    x1: 12,
    y1: 160,
    x2: 12,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "a1c05c42-8202-463a-9fd2-34c8d5fa4d06",
    x1: 35,
    y1: 160,
    x2: 35,
    y2: 117
  }), /*#__PURE__*/React.createElement("path", {
    className: "a1c05c42-8202-463a-9fd2-34c8d5fa4d06",
    d: "M12,117.17a11.5,11.5,0,0,1,23,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ae93a8a8-8cf9-48ef-827b-c1294b93889d",
    cx: 24,
    cy: 176.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a1cafad3-46ac-46ea-b625-e40b6b079958",
    x1: 35.42,
    y1: 127.46,
    x2: 30.54,
    y2: 127.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "a1cafad3-46ac-46ea-b625-e40b6b079958",
    x1: 35.5,
    y1: 133.5,
    x2: 30.5,
    y2: 133.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a1cafad3-46ac-46ea-b625-e40b6b079958",
    x1: 35.5,
    y1: 139.5,
    x2: 30.5,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "eefabf8a-b0fc-426c-a0fc-5ea00847762f",
    x1: 24,
    y1: 176,
    x2: 24,
    y2: 130
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempProfilWhite);
export default __webpack_public_path__ + "static/media/coef_temp_profil_white.8d7f0373993f3c285dac9810e778cd2f.svg";
export { ForwardRef as ReactComponent };